@let productCardExpanded = $productCardExpanded();
@let request = $request();
@let requestProducts = $request().products;
@let requestDevices = $request().devices;
@let isInsideSummary = $isInsideSummary();
@let alternateInstallerBanner = $alternateInstallerBanner();

@if (
  isInsideSummary && devicesProductsAndAddedDevicesAmountMismatchHintData()
) {
  <section class="mb-3">
    <ng-container [ngTemplateOutlet]="devicesAmountMismatch"></ng-container>
  </section>
}

@if (alternateInstallerBanner.isAlternateInstaller) {
  <section
    class="mb-3"
    [ngClass]="{
      'md:w-1/2 md:mx-auto mt-4': !isInsideSummary,
    }"
  >
    <div
      class="flex items-start gap-3 border-l-4 border-(--x-color-green) pl-3 py-1.5 bg-(--x-color-grayBG) rounded-r-lg"
    >
      <tui-icon
        icon="@tui.check"
        class="text-(--x-color-green) mt-0.5 size-6 text-base"
      ></tui-icon>
      <div class="flex flex-col">
        <p
          class="text-[11px] text-(--x-dark-secondary) font-bold uppercase mb-0.5 leading-none"
        >
          Вы исполнитель части услуг
        </p>
        <p class="x-text-dark-main font-extrabold text-[15px] leading-tight">
          {{ alternateInstallerBanner.productsLabel }}
        </p>
      </div>
    </div>
  </section>
}

<section
  class="mt-4.5"
  [ngClass]="{
    'grid grid-cols-3 gap-5 items-stretch': isInsideSummary,
    'md:w-1/2 md:mx-auto': !isInsideSummary,
  }"
>
  @if (
    !isInsideSummary && devicesProductsAndAddedDevicesAmountMismatchHintData()
  ) {
    <div class="flex justify-center mb-3">
      <ng-container [ngTemplateOutlet]="devicesAmountMismatch"></ng-container>
    </div>
  }
  @if (requestProducts) {
    @for (requestProduct of requestProducts; track requestProduct.id) {
      <x-request-form-goods-item
        [requestProduct]="requestProduct"
        [requestDevices]="requestDevices"
        [expanded]="productCardExpanded[requestProduct.id]"
        [isInsideSummary]="$isInsideSummary()"
        (expandOutputEvent)="toggleExpandProductCard($event)"
      ></x-request-form-goods-item>
    }
    @if (
      (permissionService.canCompleteProducts$ | async) &&
      canCompleteSomeProducts() &&
      !isInsideSummary
    ) {
      <button
        tuiButton
        [style.border-radius.rem]="100"
        type="button"
        size="m"
        class="mt-2 w-full"
        [disabled]="!!(isLoading$ | async)"
        (click)="tryToCompleteAllProducts()"
      >
        {{ 'request_form.goods.complete_all' | translate }}
      </button>
    }
  }
  <!--     ДОБАВЛЕНИЕ ПРОДУКТА/УСЛУГИ-->
  <!--    <x-request-form-goods-request-product-adding-->
  <!--      class="block mt-5"-->
  <!--    ></x-request-form-goods-request-product-adding>-->

  @if (request.productPresetSnapshot) {
    <tui-accordion size="m">
      <button tuiAccordion>
        {{ 'request_form.goods.preset_applied' | translate }}
        {{ request.productPresetSnapshot.name }}
      </button>
      <tui-expand class="col-start-1 mt-4.5">
        <ng-container *tuiItem>
          <ul class="typo-body-m leading-6 text-(--tui-text-primary)">
            @for (
              presetProduct of request.productPresetSnapshot.products;
              track presetProduct.id
            ) {
              <li
                class="relative mt-3 first:mt-0 ps-6 wrap-break-word before:absolute before:start-0 before:top-2 before:size-2 before:rounded-full before:bg-(--tui-background-accent-1) before:content-['']"
              >
                {{ 'request_products.' + presetProduct.id | translate }}
                <span tuiBadge class="mx-1 !font-medium mb-1" size="m">{{
                  presetProduct.amount
                }}</span>
              </li>
            }
          </ul>
        </ng-container>
      </tui-expand>
    </tui-accordion>
  }
</section>

@if (!requestProducts?.length) {
  <div class="x-card x-card_size_m x-white text-center">
    <x-empty-block [title]="'request_form.goods.empty_list' | translate" />
  </div>
}
<ng-template #devicesAmountMismatch>
  <span
    class="inline-block w-full md:w-fit px-3 py-2 rounded-md bg-(--tui-status-warning)"
  >
    {{
      'request_form.goods.devices_mismatch'
        | translate
          : {
              devicesAmountInRequest:
                devicesProductsAndAddedDevicesAmountMismatchHintData()!
                  .devicesAmountInRequest,
              deviceProductsAmountInRequest:
                devicesProductsAndAddedDevicesAmountMismatchHintData()!
                  .deviceProductsAmountInRequest,
            }
    }}
  </span>
</ng-template>
